// import { httpgst, http } from '../../main'
import { httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  elements_get ({commit, dispatch}, payload) {
    // let url4 = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    // http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    // http.get(url4, {}, options)
    //   .then(
    //     response => {
    //       commit('onGetLogged', {event: payload.event, response: response})
    //     },
    //     error => {
    //       commit('onError', {event: payload.event, error: error})
    //     }
    //   )
    let url = 'api/validators'
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetValidators', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
    let url2 = 'api/areas'
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url2, {}, options)
      .then(
        response => {
          commit('onGetAreas', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  substitutes_get ({commit, dispatch}, payload) {
    let url3 = 'api/substitute/' + payload.event.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url3, {}, options)
      .then(
        response => {
          commit('onGetSubstitutes', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getWorkflows ({commit, dispatch}, payload) {
    let url = 'api/workflow-area-all/' + payload.event.id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetWorkflows', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  areaWorkflows ({commit, dispatch}, payload) {
    let url = 'api/workflow-area/' + payload.event.area
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onAreaWorkflows', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getGroup ({commit, dispatch}, payload) {
    let url = 'api/workflow-area/' + payload.event.area
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetGroup', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  postItem ({commit, dispatch}, payload) {
    let url = 'api/workflow'
    let params = {
      'name': payload.event.item.name,
      'description': payload.event.item.description,
      'gst_validators_id': payload.event.item.gst_validator_id,
      'gst_substitute_id': payload.event.item.gst_substitute_id,
      'gst_area_id': payload.event.item.gst_area
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('onPostItem', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  putItem ({commit, dispatch}, payload) {
    let url = 'api/workflow/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name,
      'description': payload.event.item.description,
      'gst_validators_id': payload.event.item.gst_validators_id,
      'gst_substitute_id': payload.event.item.gst_substitute_id,
      'status_validator': payload.event.item.validator.status,
      'gst_approver_id': payload.event.item.gst_approver_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  changePlace ({commit, dispatch}, payload) {
    let url = 'api/workflow-position/' + payload.event.from + '/' + payload.event.to
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, {}, {})
      .then(
        response => {
          commit('onChangePlace', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  deleteItem ({commit, dispatch}, payload) {
    let url = 'api/workflow/' + payload.event.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  async downloadReport({ commit }, { event }) {
    try {
      const url = `api/workflow/report`
      
      const options = { emulateJSON: false, headers: { 'Content-Type': `application/xlsx` } }
      
      const params = { responseType: 'blob' }
      
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, params, options)
      
      const reportBinary = response.data
      
      event.context.forceFileDownload(reportBinary, `report-workflows.xlsx`)

    } catch (error) {
      console.log(error)
      event.context.showNotification(error, 'error')
    } finally {
      event.context.loadingExcelReport = false
    }
  }
}

const mutations = {
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
    payload.event.context.getWorkflows()
  },
  onGetValidators (state, payload) {
    let validators = payload.response.data.data
    payload.event.context.validators = validators
  },
  onGetAreas (state, payload) {
    let areas = payload.response.data.data
    payload.event.context.areas = areas
  },
  onGetWorkflows (state, payload) {
    let workflows = payload.response.data.data
    let workTemp = []
    for (let i = 0; i < workflows.length; i++) {
      let item = workflows[i]
      let temp = {}
      temp.name = item[0].area.name
      temp.id = item[0].id
      temp.gst_area_id = item[0].gst_area_id
      temp.items = item
      workTemp.push(temp)
    }
    payload.event.context.workflows = workTemp
  },
  onAreaWorkflows (state, payload) {
    let AreaWorkflows = payload.response.data.data
    payload.event.context.placeOptions = AreaWorkflows
    payload.event.context.editPlaceDialog = true
  },
  onGetSubstitutes (state, payload) {
    let substitutes = payload.response.data.data
    const subtituteNull = {
      user: {
        name: payload.event.context.$t('workflow.noSubstitute')
      },
      id: null
    }
    if (substitutes.length > 0) {
      substitutes.unshift(subtituteNull)
    }
    payload.event.context.substitutes = substitutes
  },
  onPostItem (state, payload) {
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.confirmDialog = false
    payload.event.context.confirmDialogW = false
    payload.event.context.closeItem()
    payload.event.context.closeWorkflow()
    payload.event.context.loading = false
  },
  onPut (state, payload) {
    payload.event.context.refresh()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeEditWorkflow()
    payload.event.context.closeViewWorkflow()
    payload.event.context.closeViewApprove()
    payload.event.context.loading = false
  },
  onDelete (state, payload) {
    payload.event.context.refresh()
    payload.event.context.closeViewWorkflow()
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.removeDialog = false
    payload.event.context.loading = false
  },
  onChangePlace (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.closeEditPlace()
    payload.event.context.closeViewWorkflow()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workflow.js